import React, { Component } from 'react';

import { Link, withRouter } from 'react-router-dom';

import classNames from 'classnames';

import Image from 'Demora/image';

import ReduxConnect from 'Demora/redux-connect';

import './FeedItem.scss';

import moment from 'moment';

import { Tooltip } from 'reactstrap';

import Feel from '../Feels/Feel';

import FeedItemActions from '../Actions/FeedItemActions';

import asyncComponent from 'Demora/AsyncComponent';

var NewCommentBox = asyncComponent(
	() =>
		import(/* webpackChunkName: "new_Comment_box" */ '../Posts/NewCommentBox')
);

import NextToNamePosts from 'resources/assets/react-app/uiHooks/react-social/nextToNamePosts';

import Comment from '../Comment';

import socialHttp from '../../../../../utils/socialHttp';

import Loading from 'Demora/Loading';

import Lightbox from 'yet-another-react-lightbox';
import Video from 'yet-another-react-lightbox/plugins/video';
import 'yet-another-react-lightbox/styles.css';

import ShowPostText from './ShowPostText';

import http from 'Demora/http';

import SocialShare from './SocialShare';

import modal from 'Demora/modals/modal';

import $script from 'scriptjs';

const number_records = 20;

class FeedItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			feed: null,
			imageInLightBox: null,
			toggleToolTipPostAge: {},
			videoInLightBox: {},
			youtubeplaying: {},
			youtubeVids: null,
		};

		if (!props.post.id) {
			http
				.post('/data/log_error', {
					stacktrace: JSON.stringify(props.post),
					url: window.location.href,
					type: 'props.post undefined',
				})
				.catch((e) => {
					throw e;
				});
		}

		this.uniqueID =
			props.post.id.replace(/[^a-zA-z0-9]/g, '') + '-a' + new Date().getTime();
	}

	componentDidMount() {
		const out = [],
			youtubeIds = {};

		this.getYouTubeLinks().map((ma, i) => {
			if (i === 0) {
				this.setupYouTubeAPI();
			}

			const id = this.guidGenerator();

			youtubeIds[ma] = id;

			out.push(
				<div id={id} key={id} />
				/*
				<iframe
					style={{ minHeight: '250px' }}
					key={i}
					width='100%'
					src={'https://youtube.com/embed/' + ma[2]}
					frameBorder='0'
					allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
					allowFullScreen
				/>
				*/
			);
		});

		this.setState({
			youtubeIds,
			youtubeVids: out,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		const props = this.props;

		if (
			!prevProps.youtube ||
			prevProps.youtube === props.youtube ||
			props.youtube === 1
		) {
			return;
		}

		this.getYouTubeLinks().map((videoId, i) => {
			const divId = this.state.youtubeIds[videoId];

			var player = new props.youtube.Player(divId, {
				height: '200',
				width: '275',
				videoId,
				playerVars: {
					playsinline: 1,
				},
				events: {
					onStateChange: this.youtubeOnStateChange,
				},
			});
		});
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	getYouTubeLinks() {
		if (!this.props.post.m) {
			return [];
		}
		const m = this.props.post.m.m;
		const urlRegex = [
			/https?:\/\/(www\.)?youtube.com\/watch\?v=([0-9a-zA-z\-\_]+)/g,
			/https?:\/\/(www\.)?youtu.be\/([0-9a-zA-z\-\_]+)/g,
		];

		const out = [],
			links = [];

		let ma;

		urlRegex.map((r) => {
			while ((ma = r.exec(m))) {
				links.push(ma[2]);
			}
		});

		return links;
	}

	guidGenerator() {
		const S4 = function () {
			return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
		};
		return (
			S4() +
			S4() +
			'-' +
			S4() +
			'-' +
			S4() +
			'-' +
			S4() +
			'-' +
			S4() +
			S4() +
			S4()
		);
	}

	setupYouTubeAPI() {
		// https://developers.google.com/youtube/iframe_api_reference

		const props = this.props;

		if (props.youtube) {
			return;
		}

		window.onYouTubeIframeAPIReady = () => {
			props.dispatch({
				type: 'LOAD_YOUTUBE',
				youtube: window.YT,
			});
		};
		props.dispatch({
			type: 'LOAD_YOUTUBE',
			youtube: 1,
		});
		$script('https://www.youtube.com/iframe_api');
	}

	youtubeOnStateChange = (a) => {
		/*
-1 (unstarted)
0 (ended)
1 (playing)
2 (paused)
3 (buffering)
5 (video cued).
*/

		const videoId = a.target.options.videoId;

		const youtubeplaying = Object.assign({}, this.state.youtubeplaying);

		if (!youtubeplaying[videoId]) {
			switch (a.data) {
				case 3:
					const ce = new CustomEvent('react_social_play_video', {
						view: window,
						bubbles: true,
						detail: {
							i: videoId,
							pid: this.props.post.h,
							t: 'yt',
						},
					});

					document.dispatchEvent(ce);
					youtubeplaying[videoId] = 3;
					this.setState({
						youtubeplaying,
					});
					break;
			}
		}
	};

	togglePostAge = (post) => {
		let t = this.state.toggleToolTipPostAge;

		t[post] = !t[post];

		this.setState({
			toggleToolTipPostAge: t,
		});
	};

	showMoreComments = (event) => {
		const props = this.props;

		event.preventDefault();

		const post = props.post;

		const ce = new CustomEvent('react_social_click_on_show_more_comments', {
			view: window,
			bubbles: true,
			detail: {
				pid: post.h,
			},
		});

		document.dispatchEvent(ce);

		const endCursor = props.post.c.i.endCursor;

		socialHttp(
			'get',
			'/data/feed/' +
				props.post.id +
				'/comments?limit=' +
				number_records +
				'&after=' +
				endCursor
		).catch((e) => {
			throw e;
		});
	};

	toggleLightImageBox = (i) => {
		if (i === '') {
			return this.setState({
				imageInLightBox: '',
			});
		}

		const post = this.props.post;

		const ce = new CustomEvent('react_social_view_image', {
			view: window,
			bubbles: true,
			detail: {
				i,
				pid: post.h,
			},
		});

		document.dispatchEvent(ce);

		const image = post.m.i[i];

		this.setState({
			imageInLightBox: Image(image, 0),
		});
	};

	toggleLightVideoBox = (i) => {
		if (i === '') {
			return this.setState({
				videoInLightBox: '',
			});
		}

		const post = this.props.post;

		const video = post.m.v[i];

		if (!video.r) {
			return this.setState({
				videoInLightBox: {
					src: video.s,
					type: video.t,
				},
			});
		}

		const ce = new CustomEvent('react_social_play_video', {
			view: window,
			bubbles: true,
			detail: {
				i,
				pid: post.h,
			},
		});

		document.dispatchEvent(ce);

		socialHttp('put', '/data/feed/' + post.id + '/playVideo', {
			i,
		}).then((data) => {
			if (!data.rufP || this.unmounted) {
				return;
			}

			this.setState({
				videoInLightBox: {
					src: data.url ?? video.s,
					type: video.t,
				},
			});
		});
	};

	savePost = (e, post) => {
		e.preventDefault();

		socialHttp('post', '/data/feed/' + post.id + '/savedPost').catch((e) => {
			throw e;
		});
	};

	deleteSavedPost(e, post) {
		e.preventDefault();

		socialHttp('delete', '/data/feed/' + post.id + '/savedPost').catch((e) => {
			throw e;
		});
	}

	openSocialShare = () => {
		let props = this.props;

		let post = props.post;

		modal({
			id: 'social_share_modal',
			header: 'Share',
			body: <SocialShare post={post} />,
			className: 'modal-max900-width',
		});
	};

	render() {
		const state = this.state;

		const props = this.props;

		const post = props.post;

		if (post.d == 1) {
			return null;
		}

		const obj = post.obj;

		const uid =
			obj.split('-')[1] !== 'g' && !obj.split('-')[1] !== 'u'
				? obj
				: post.u + '-u';

		const user = props.users[uid];

		if (post.user) {
			user.dontLink = true;
		}

		if (!user) {
			return null;
		}

		if (post.m.s) {
			const sharedPostId = post.m.s.split('-');

			const tt_post_id = this.uniqueID;

			const tt_post_id_r = tt_post_id + '-r';

			const sharedPost =
				props.feed[sharedPostId.slice(0, 2).join('-')].p[
					sharedPostId.slice(0, 3).join('-')
				];

			return (
				<div
					data-pid={post.h}
					className={classNames(
						'card panel-white post panel-shadow pms p-a-1 mb-3',
						props.className
					)}
				>
					<div className='post-title p-2'>
						{post.title && (
							<span>
								{post.title}
								<hr />
							</span>
						)}
					</div>
					<div className='shared_post_header'>
						<Link to={'/profile/' + uid}>
							<img
								src={Image(user.image, 50)}
								className='rounded avatar profile_image_smaller float-left'
								alt='user profile image'
							/>
							<span className='shared_post_header_name'>
								<strong>
									{props.users[uid].first_name +
										' ' +
										props.users[uid].last_name}
								</strong>
								&nbsp;
							</span>
						</Link>
						<span className='text_muted'>
							shared this{' '}
							<span id={tt_post_id} className='post_time'>
								{!props.dontShowTime && (
									<Link to={'/post/' + post.id}>
										{moment.utc(post.t).local().from()}
									</Link>
								)}
							</span>
						</span>
						<FeedItemActions
							post={post}
							postUser={user}
							className='feedActions'
						/>
					</div>
					{sharedPost && !sharedPost.d ? (
						<FeedItem2 post={sharedPost} />
					) : (
						<div className='text-center m-3'>This post has been deleted.</div>
					)}
				</div>
			);
		}

		let tooltipTimestamp = 'post_age' + this.uniqueID;

		let next = 0;

		if (post.c) {
			next = post.c.i.total - Object.keys(post.c.p).length;
		}

		let shownEx = false;

		return (
			<div
				data-pid={post.h}
				className={classNames(
					'card panel-white post panel-shadow mb-3',
					props.sideBySide && 'commentsSideBySide',
					props.forceSideBySide && 'forceCommentsSideBySide',
					props.className
				)}
				style={props.style}
			>
				{post.temp ? (
					<div className='newPost text-center'>
						<Loading />
					</div>
				) : (
					''
				)}
				<div className={classNames()}>
					<div className='post-title p-2'>
						{post.title && (
							<span>
								{post.title}
								<hr />
							</span>
						)}
					</div>
					<div className='post-heading'>
						<FeedItemActions
							className='feedActions'
							viewer={props.viewer}
							post={post}
						/>
						<div className='d-flex'>
							<div className='image'>
								<Link to={'/profile/' + uid}>
									<img
										src={Image(user.image, 200)}
										className='rounded avatar'
										alt='user profile image'
									/>
								</Link>
							</div>
							<div className='meta'>
								<div className='title'>
									{user.dontLink ? (
										<div className='post-user-name h6 text-decoration-none'>
											{user.first_name + ' ' + user.last_name}
											<NextToNamePosts obj={user.id + '-u'} />
										</div>
									) : (
										<Link
											to={'/profile/' + post.u + '-u'}
											className='post-user-name h6 text-decoration-none'
										>
											{user.first_name + ' ' + user.last_name}
											<NextToNamePosts obj={user.id + '-u'} />
										</Link>
									)}
									{post.obj.split('-')[1] == 'g' &&
										(!props.match.params.obj ||
											props.match.params.obj.split('-')[1] != 'g') && (
											<span>
												<span className=''>
													&nbsp;posted to the group&nbsp;
												</span>
												<Link
													to={
														'/profile/' +
														post.obj.split('-').slice(0, 2).join('-')
													}
													className='post-user-name h6 text-decoration-none'
												>
													{props.users[post.obj].first_name +
														' ' +
														props.users[post.obj].last_name}
												</Link>
											</span>
										)}
								</div>
								{!props.dontShowTime && (
									<h6 id={tooltipTimestamp} className='text-muted time'>
										<Link to={'/post/' + post.id}>
											{moment.utc(post.t).local().from()}
										</Link>
									</h6>
								)}
								{!props.dontShowTime && (
									<Tooltip
										placement='top'
										isOpen={state.toggleToolTipPostAge[tooltipTimestamp]}
										target={tooltipTimestamp}
										toggle={() => this.togglePostAge(tooltipTimestamp)}
									>
										{moment.utc(post.t).local().format('lll')}
									</Tooltip>
								)}
							</div>
						</div>
					</div>
					<div className='post-description'>
						{!post.m.m ? '' : <ShowPostText post={post} />}
						{post.m.m && this.state.youtubeVids}
					</div>
					<div className='post-image text-center'>
						{!post.m.i
							? ''
							: post.m.i.map((im, i) => {
									return (
										<p key={i}>
											<img
												src={Image(im, 400)}
												style={{ maxWidth: '100%' }}
												className='rounded'
												onClick={() => this.toggleLightImageBox(i)}
											/>
										</p>
									);
								})}

						{!post.m.v
							? ''
							: post.m.v.map((im, i) => {
									return (
										<p key={i}>
											{/*
										<video style={{ maxWidth: '320px', maxHeight: '320px', }} controls>
											<source src={im} type={'video/'+type} />
											Your browser does not support the video tag.
										</video>
									*/}
											<img
												src={Image(im.i, 400)}
												onClick={() => this.toggleLightVideoBox(i)}
											/>
										</p>
									);
								})}
					</div>
					<div className='post-description'>
						<Feel post={post} />

						{props.user.id && (
							<span className='float-right'>
								{props.user.id + '-u' == post.obj &&
									props.user.id == post.u && (
										<span
											onClick={this.openSocialShare}
											className='btn btn-default stat-item btn-responsive'
										>
											<small className='text-muted'>
												<i className='fab fa-facebook-f btn-responsive mr-2' />
												<i className='fab fa-twitter btn-responsive mr-2' />
												<i className='fab fa-linkedin-in btn-responsive' />
											</small>
										</span>
									)}

								{post.saved ? (
									<a
										alt='Delete saved post'
										href='#'
										onClick={(event) => this.deleteSavedPost(event, post)}
										className='btn btn-default stat-item btn-responsive'
									>
										<small className='text-muted'>
											Bookmarked{' '}
											<i className={classNames('fa fa-trash icon')}></i>
										</small>
									</a>
								) : (
									<a
										alt='Save'
										href='#'
										onClick={(event) => this.savePost(event, post)}
										className='btn btn-default stat-item btn-responsive'
									>
										<i className={classNames('fas fa-bookmark')}></i>
									</a>
								)}
							</span>
						)}

						{!post.can.i && <div style={{ height: '0.75rem' }} />}
					</div>
				</div>
				<div className='post-footer'>
					{post.can.i && <NewCommentBox obj={post.id} />}

					<ul className='comments-list'>
						{post.c &&
							Object.keys(post.c.p)
								.filter((a) => {
									return !post.c.p[a].d;
								})
								.sort((a, b) => {
									if (post.c.p[a].t == post.c.p[b].t) {
										return 0;
									}

									return post.c.p[a].t > post.c.p[b].t ? 1 : -1;
								})
								.map((kc, i) => {
									const comment = post.c.p[kc];

									let showEx = false;

									if (
										!shownEx &&
										comment.ex &&
										post.c.i.total > Object.keys(post.c.p).length
									) {
										shownEx = true;

										showEx = true;
									}

									return (
										<Comment
											key={kc}
											showEx={showEx}
											comment={comment}
											showMoreComments={this.showMoreComments}
											dontShowTime={props.dontShowTime}
										/>
									);
								})}

						{next > 0 && (
							<li className='comment text-center'>
								<a href='#' onClick={this.showMoreComments}>
									<small>Show more comments...</small>
								</a>
							</li>
						)}
					</ul>
				</div>
				<Lightbox
					open={!!state.imageInLightBox}
					close={() => this.toggleLightImageBox('')}
					slides={[{ src: state.imageInLightBox }]}
				/>
				<Lightbox
					open={!!state.videoInLightBox.src}
					close={() => this.toggleLightVideoBox('')}
					plugins={[Video]}
					video={{
						controls: true,
						playsInline: true,
						autoPlay: true,
					}}
					slides={[
						{
							type: 'video',
							width: 1280,
							height: 720,
							//	poster: "/public/poster-image.jpg",
							sources: [
								{
									src: state.videoInLightBox.src,
									type: state.videoInLightBox.type,
								},
							],
						},
					]}
				/>
			</div>
		);
	}
}

const FeedItem2 = withRouter(
	ReduxConnect(FeedItem, {
		feed: 'feed',
		user: 'user',
		users: 'users',
		youtube: 'youtube',
	})
);

export default FeedItem2;
